import { B, cls } from "./context.js";

// Öğrencinin aylık ücreti: sınıf ücreti (tam/yarım gün) + servis − indirim.
// payment.override verilmişse (yarım ay, özel anlaşma) toplam onunla değiştirilir.
export function feeFor(student, payment) {
  const c = cls(student.classId);
  const base = student.schedule === "yarim" ? c.tuitionHalf : c.tuition;
  const service = student.service ? B().serviceFee : 0;
  const pct = student.discount?.pct ?? 0;
  const discount = Math.round((base + service) * pct / 100);
  const computed = base + service - discount;
  const override = payment?.override ?? null;
  return {
    base, service, discount, pct, computed, override,
    total: override ?? computed,
    discountLabel: student.discount?.label ?? null,
    half: student.schedule === "yarim",
  };
}
